import React from 'react';
import PropTypes from 'prop-types';
import NGNFooter from './NGNFooter';
import TNLFooter from './TNLFooter';
import TNLComFooter from './TNLComFooter';
import WLSFooter from './WLSFooter';

const BRANDS = Object.freeze({
  NGN: 'ngn',
  TNL: 'tnl',
  TNL_COM: 'tnl_com',
  WLS: 'wls'
});

const FOOTERS = Object.freeze({
  [BRANDS.NGN]: NGNFooter,
  [BRANDS.TNL]: TNLFooter,
  [BRANDS.TNL_COM]: TNLComFooter,
  [BRANDS.WLS]: WLSFooter,
  default: () => null
});

const BrandFooter = ({ brand }) => {
  const FooterComponent = FOOTERS[brand] || FOOTERS.default;
  return <FooterComponent />;
}

BrandFooter.propTypes = {
  brand: PropTypes.string.isRequired
};

export default BrandFooter;
